module.exports = __webpack_public_path__ + "img/icon-account-phone@3x.ea81765f.png";